function cov_2nuqyhsoz5() {
  var path = "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts";
  var hash = "b5dac92fa0dfaf5b1ddf31345c9c5759fd8d16af";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b5dac92fa0dfaf5b1ddf31345c9c5759fd8d16af"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2nuqyhsoz5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2nuqyhsoz5();
export { default } from "./AutocompleteInput.mjs";
//# sourceMappingURL=index.mjs.map